<template>
  <b-row class="line-chart no-gutters">
   
    <b-col class="chart-container flex-item" sm="12">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 560 244" style="enable-background:new 0 0 560 244;" xml:space="preserve">
      
        //**************************************gridbox********************************************
        
        <g id="graphbackground">
        <rect x="34" y="16" rx="5" ry="5" :width="graphWidth" :height="graphHeight" style="fill:#fff;stroke:none;"/>
        </g>
        //**************************************END - gridbox********************************************
        
        //**************************************grid********************************************
        <!--<g id="grid">-->
        <!--//**************************************y labels*******************************************-->
        <g id="ylabels">
          <!--labels without decimal-->
          <g class="y-labels" v-if="lblSkipY>=5">
            <text :class="{'orange-label':line.hightlight}" style="fill:#001965; font-family:Sans,Verdana; font-size:12px;" v-for="(line,index) in ylabelpos" v-bind:key="index" :y="line.y" :x="line.x" text-anchor="end">{{line.value}}</text>
          </g>
        <!--labels with decimal-->
          <g class="y-labels" v-if="lblSkipY<5">
            <text :class="{'orange-label':line.hightlight}" style="fill:#001965; font-family:Sans,Verdana; font-size:12px;" v-for="(line,index) in ylabelpos" v-bind:key="index" :y="line.y" :x="line.x" text-anchor="end">{{line.value|labelY}}</text>
          </g> 
        </g>
        <!--//**************************************END - y labels********************************************-->
        
        <!--//**************************************x labels********************************************-->
        <g id="xlabels">
        <g class="x-labels">
        <text :class="{'hideOnSm': (index%2!=0 && line.value!=lblEndX && lblSkipX<2)}" text-anchor="middle" style="fill:#001965; font-family:Sans,Verdana; font-size:12px;" v-for="(line,index) in xlabelpos" v-bind:key="index" :y="line.y" :x="line.x">{{line.value|labelX(disease)}}</text>
        </g>
        </g>
        <!--//**************************************END - x labels********************************************-->
        
        <!--//**************************************gridlines********************************************-->
        <g id="gridlines">
          <line :class="{'orange-line':line.hightlight}" v-for="(line,index) in gridlines" v-bind:key="index" :x1="line.x1" :x2="line.x2" :y1="line.y1" :y2="line.y2" style="fill:none;stroke:#CCCCCC;stroke-width:1.1017;stroke-miterlimit:10;"></line>
        </g>
        <!--**************************************END - grid********************************************-->
        
        //**************************************gridbox********************************************
        
        <g id="graphboxes">
        <rect x="34" y="16" rx="5" ry="5" :width="graphWidth" :height="graphHeight" style="fill:none;stroke:#001965;stroke-width:1.17;stroke:#001965"/>
        </g>
        //**************************************END - gridbox********************************************
        
        <!--//********************************  GRAPH CURVES  ******************************************-->
        <g id="curves">
          <g id="cancer_curve" v-if="disease=='cancer'">
            <polyline style="fill:none;stroke:#001965;stroke-width:3.9806;stroke-linecap:round;stroke-linejoin:round;" points="
            34.69,124.57 51.78,123.29 68.87,122.01 85.96,120.56 103.05,119.12 120.14,117.58 137.23,115.96 154.32,114.35 171.55,112.56 
            188.64,110.77 205.73,108.81 222.82,106.85 239.91,104.89 257,102.76 274.09,100.63 291.19,98.33 308.28,96.03 325.37,93.65 
            342.46,91.18 359.55,88.71 376.64,86.07 393.73,83.43 410.82,80.7 427.92,77.89 445.01,74.99 462.23,72.1 479.32,69.03 
            496.41,65.96 513.5,62.81 530.59,59.58 532.36,59.23 			"/>
            <path style="fill:#001965;" d="M547.69,56.25c-6.69,4.08-14.75,10.38-19.36,16.3l2.02-12.93l-6.72-11.23
            C530.12,52.15,539.95,54.98,547.69,56.25z"/>
          </g>
         
          <g id="dyslip" v-if="disease=='dyslip'" transform="translate(0, -4)scale(1.005, 1.03)">
            <g>
              <polyline style="fill:none;stroke:#001965;stroke-width:3.9407;stroke-linecap:round;stroke-linejoin:round;" points="
              35.19,135.2 60.9,130.11 86.4,125.21 112.1,120.4 137.81,115.78 163.3,111.26 189.01,106.92 214.71,102.67 240.42,98.62 
              265.92,94.66 291.62,90.79 317.33,87.12 342.83,83.63 368.53,80.23 394.24,76.93 419.94,73.82 445.44,70.81 471.14,67.98 
              496.85,65.24 522.55,62.7 532.66,61.72 			"/>
              <g>
              <path style="fill:#001965;" d="M548.05,60.24c-6.98,3.38-15.53,8.83-20.63,14.22l3.22-12.55l-5.55-11.7
              C531.13,54.54,540.55,58.26,548.05,60.24z"/>
              </g>
            </g>
          </g>
          <g id="hypertension" v-if="disease=='hypertension'" transform="translate(0, 7)scale(1, 0.94)">
          <g>
          <polyline style="fill:none;stroke:#001965;stroke-width:4.0821;stroke-linecap:round;stroke-linejoin:round;" points="
          35.43,174.1 52.69,169.81 69.74,165.45 86.79,161.03 104.05,156.61 121.1,152.12 138.36,147.63 155.41,143.14 172.45,138.52 
          189.71,133.97 206.76,129.28 224.02,124.66 241.07,119.91 258.12,115.16 275.38,110.41 292.43,105.59 309.69,100.71 
          326.74,95.82 343.79,90.94 361.05,85.99 378.1,80.97 395.36,75.96 412.41,70.87 429.45,65.79 446.71,60.64 463.76,55.5 
          481.02,50.28 498.07,45.07 532.38,34.44 534.15,33.89 			"/>
          <g>
          <path style="fill:#001965;" d="M549.43,29.1c-6.35,4.92-13.85,12.27-17.86,18.83l0.58-13.41l-8.13-10.67
          C531.06,26.93,541.4,28.69,549.43,29.1z"/>
          </g>
          </g>
          </g>
          <g id="pcos_1_" v-if="disease=='pcos'">
          <g>
          <polyline style="fill:none;stroke:#001965;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;" points="35.99,184.78 
          61.68,182.04 87.37,178.86 113.06,175.02 138.88,170.63 164.56,165.7 190.25,160.22 215.94,154.29 241.76,147.71 267.45,140.59 
          293.14,132.91 318.83,124.69 344.65,115.91 370.34,106.59 396.03,96.83 421.85,86.41 447.54,75.45 473.23,63.93 498.91,51.87 
          524.73,39.26 536.46,33.25 			"/>
          <g>
          <path style="fill:#001965;" d="M550.42,26.1c-5.32,5.8-11.34,14.14-14.14,21.14l-1.66-13.04l-9.62-8.96
          C532.32,27.04,542.6,27.03,550.42,26.1z"/>
          </g>
          </g>
          </g>
          <g id="nafld" v-if="disease=='nafld'" transform="translate(0, -1)">
          <g>
          <polyline style="fill:none;stroke:#001965;stroke-width:5.2447;stroke-linecap:round;stroke-linejoin:round;" points="
          35.78,213.64 60.86,204.9 87.26,196.17 112.35,187.44 138.75,177.74 163.83,169.01 190.23,160.28 215.32,151.55 241.72,142.81 
          266.8,134.08 293.2,124.38 318.29,115.65 344.69,106.92 369.77,98.19 396.17,89.46 421.26,80.72 447.66,71.02 472.74,62.29 
          499.14,53.56 524.23,44.83 531.1,42.56 			"/>
          <g>
          <path style="fill:#001965;" d="M550.63,36.1c-8.06,6.45-17.54,16.04-22.57,24.54l0.48-17.23l-10.66-13.55
          C526.98,33.68,540.31,35.73,550.63,36.1z"/>
          </g>
          </g>
          </g>
          <g id="ost-female" v-if="disease=='osteoarth-female'" transform="translate(0, -4)scale(1, 1.03)">
          <g>
          <polyline style="fill:none;stroke:#001965;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;" points="35.43,191 
          52.46,187.48 69.69,183.82 86.72,180.15 103.96,176.48 120.99,172.82 138.02,169 155.25,165.18 172.28,161.36 189.52,157.54 
          206.55,153.72 223.78,149.75 240.81,145.93 258.05,141.96 275.08,137.84 292.11,133.87 309.34,129.74 326.37,125.77 
          343.6,121.64 360.63,117.37 377.87,113.24 394.9,108.97 412.13,104.69 429.16,100.41 446.19,95.98 463.43,91.7 480.46,87.27 
          497.69,82.69 514.72,78.26 531.95,73.68 533.83,73.17 			"/>
          <g>
          <path style="fill:#001965;" d="M548.99,69.1c-6.42,4.56-14.05,11.46-18.25,17.71l1.11-13.1l-7.53-10.78
          C531.08,66.24,541.14,68.37,548.99,69.1z"/>
          </g>
          </g>
          </g>
          <g id="ost-male" v-if="disease=='osteoarth-male'">
          <polyline style="fill:none;stroke:#001965;stroke-width:3.9961;stroke-linecap:round;stroke-linejoin:round;" points="
          35.43,198.8 52.67,193.64 69.73,188.48 86.79,183.18 103.84,178.02 120.9,172.72 138.14,167.41 155.2,162.11 172.26,156.66 
          189.31,151.21 206.55,145.77 223.61,140.32 240.67,134.73 257.72,129.14 274.78,123.55 292.02,117.96 309.08,112.22 
          326.14,106.49 343.19,100.76 360.25,94.88 377.49,89.15 394.55,83.27 411.61,77.25 428.66,71.23 445.91,65.35 462.96,59.19 
          480.02,53.17 497.07,47 514.13,40.69 531.37,34.53 533.73,33.66 			"/>
          <g>
          <path style="fill:#001965;" d="M548.43,28.22c-5.97,5.13-12.93,12.68-16.54,19.29l-0.09-13.14l-8.47-10.03
          C530.36,27.01,540.56,28.22,548.43,28.22z"/>
          </g>
          </g>
          
          <g id="diab" v-if="disease=='diab'">
          <polyline style="fill:none;stroke:#001965;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;" points="36.04,162.6 
          53.15,163.51 70.27,164.12 87.38,164.35 104.49,164.27 121.61,163.89 138.72,163.21 155.83,162.14 172.94,160.7 190.06,159.03 
          207.17,156.98 224.28,154.55 241.4,151.81 258.51,148.78 275.62,145.36 292.74,141.63 309.85,137.61 326.96,133.2 344.07,128.49 
          361.19,123.4 378.3,118.01 395.41,112.31 412.53,106.24 429.64,99.86 446.75,93.17 463.87,86.11 480.98,78.74 498.09,70.99 
          515.2,62.94 532.32,54.59 535.45,52.98 			"/>
          <path style="fill:#001965;" d="M549.43,45.85c-5.33,5.8-11.36,14.13-14.17,21.12l-1.64-13.05l-9.6-8.98
          C531.32,46.77,541.61,46.77,549.43,45.85z"/>
          </g>
        </g>
        
        <!--//********************************  GRAPH POINTS  ******************************************-->
        <g class="curve-points">
          <g id="current" v-if="!(userData.bmi>=40 && ((risk.current==risk.adj5 && adjustSelection==5) || 
          (risk.current==risk.adj10 && adjustSelection==10) || (risk.current==risk.adj15 && adjustSelection==15) 
          || (risk.current==risk.adj20 && adjustSelection==20)))">
            <circle r="9"  :cx="currentRisk.x" :cy="currentRisk.y" fill="#001965"></circle>
            <g class="current-text">
              <text text-anchor="middle" style="fill:#001965; font-family:verdana ,serif; font-weight: 700; font-size:28px;" :y="currentText.y" :x="currentText.x">{{risk.current|curvePoints(disease)}}</text>
            </g>
          </g>
          <g id="adj5" v-if="adjustSelection==5 && userData.calc.bmi.adj5>=20">
          <circle r="9"  :cx="adj5Risk.x" :cy="adj5Risk.y" fill="#3f9c35"></circle>
          <g class="current-text">
          <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight: 700; font-size:28px;" :y="adj5Text.y" :x="adj5Text.x">{{risk.adj5|curvePoints(disease)}}</text>
          </g>
          </g>
          <g id="adj10" v-if="adjustSelection==10 && userData.calc.bmi.adj10>=20">
          <circle r="9"  :cx="adj10Risk.x" :cy="adj10Risk.y" fill="#3f9c35"></circle>
          <g class="current-text">
          <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight: 700; font-size:28px;" :y="adj10Text.y" :x="adj10Text.x">{{risk.adj10|curvePoints(disease)}}</text>
          </g>
          </g>
          <g id="adj15" v-if="adjustSelection==15 && userData.calc.bmi.adj15>=20">
          <circle r="9"  :cx="adj15Risk.x" :cy="adj15Risk.y" fill="#3f9c35"></circle>
          <g class="current-text">
          <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight: 700; font-size:28px;" :y="adj15Text.y" :x="adj15Text.x">{{risk.adj15|curvePoints(disease)}}</text>
          </g>
          </g>
          <g id="adj20" v-if="adjustSelection==20 && userData.calc.bmi.adj20>=20">
          <circle r="9"  :cx="adj20Risk.x" :cy="adj20Risk.y" fill="#3f9c35"></circle>
          <g class="current-text">
          <text text-anchor="middle" style="fill:#3f9c35; font-family:verdana ,serif; font-weight: 700; font-size:28px;" :y="adj20Text.y" :x="adj20Text.x">{{risk.adj20|curvePoints(disease)}}</text>
          </g>
          </g>
        </g>
        <g v-if="userData.bmi<20 || (userData.calc.bmi.adj5<20 && adjustSelection==5) || (userData.calc.bmi.adj10<20 && adjustSelection==10) || (userData.calc.bmi.adj15<20 && adjustSelection==15) || (userData.calc.bmi.adj20<20 && adjustSelection==20)">
          <text text-anchor="middle" style="fill:#e64a0e; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="error20.y" :x="error20.x">
            {{$t('graph.below20-1')}}</text>
            <text text-anchor="middle" style="fill:#e64a0e; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="error20.y+20" :x="error20.x">
             {{$t('graph.below20-2')}}</text>
        </g>
        <g v-if="userData.bmi>errorAt && $i18n.locale=='en'" >
          <text text-anchor="middle" style="fill:#e64a0e; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="error50.y" :x="error50.x">
            {{$t('graph.supportedData-1')}}</text>
            <text text-anchor="middle" style="fill:#e64a0e; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="error50.y+20" :x="error50.x">
            {{$t('graph.supportedData-2')}} {{errorAt}}. {{$t('graph.supportedData-3')}}</text>
            <text text-anchor="middle" style="fill:#e64a0e; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="error50.y+40" :x="error50.x">
            {{$t('graph.supportedData-4')}} {{errorAt}}.</text>
        </g>
        
         <g v-if="userData.bmi>errorAt && $i18n.locale=='sp'" >
          <text text-anchor="middle" style="fill:#e64a0e; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="error50.y-12" :x="error50.x-12">
            {{$t('graph.supportedData-1')}}</text>
            <text text-anchor="middle" style="fill:#e64a0e; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="error50.y+5" :x="error50.x-12">
            {{$t('graph.supportedData-2')}} </text>
             <text text-anchor="middle" style="fill:#e64a0e; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="error50.y+22" :x="error50.x-12">
            {{errorAt}}. {{$t('graph.supportedData-3')}}</text>
            <text text-anchor="middle" style="fill:#e64a0e; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="error50.y+39" :x="error50.x-13">
            {{$t('graph.supportedData-4')}} {{errorAt}}.</text>
        </g>
        
        <!--******************************************** CONF INTERV *************************************************-->
        <g v-if="adjustSelection==20">
          <text text-anchor="middle" :class="{'small-ci' : ( (disease=='diab') || (disease=='osteoarth-male') || (disease=='osteoarth-female') ) }" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y" :x="confIntPos.x">
            {{$t('graph.confidenceInterval')}}</text>
            <text text-anchor="middle" :class="{'small-ci' : ( (disease=='diab') || (disease=='osteoarth-male') || (disease=='osteoarth-female') ) }" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y+20" :x="confIntPos.x">
            ({{confInt.adj20[0]|confIntvlLow(disease)}}-{{confInt.adj20[1]|confIntvlHigh(disease)}})</text>
        </g>
        <g v-if="adjustSelection==15">
          <text text-anchor="middle" :class="{'small-ci' : ( (disease=='diab') || (disease=='osteoarth-male') || (disease=='osteoarth-female') ) }" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y" :x="confIntPos.x">
            {{$t('graph.confidenceInterval')}}</text>
            <text text-anchor="middle"  :class="{'small-ci' : ( (disease=='diab') || (disease=='osteoarth-male') || (disease=='osteoarth-female') ) }" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y+20" :x="confIntPos.x">
            ({{confInt.adj15[0]|confIntvlLow(disease)}}-{{confInt.adj15[1]|confIntvlHigh(disease)}})</text>
        </g>
        <g v-if="adjustSelection==10">
          <text text-anchor="middle" :class="{'small-ci' : ( (disease=='diab') || (disease=='osteoarth-male') || (disease=='osteoarth-female') ) }" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y" :x="confIntPos.x">
            {{$t('graph.confidenceInterval')}}</text>
            <text text-anchor="middle" :class="{'small-ci' : ( (disease=='diab') || (disease=='osteoarth-male') || (disease=='osteoarth-female') ) }" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y+20" :x="confIntPos.x">
            ({{confInt.adj10[0]|confIntvlLow(disease)}}-{{confInt.adj10[1]|confIntvlHigh(disease)}})</text>
        </g>
        <g v-if="adjustSelection==5">
          <text text-anchor="middle" :class="{'small-ci' : ( (disease=='diab') || (disease=='osteoarth-male') || (disease=='osteoarth-female') ) }" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y" :x="confIntPos.x">
            {{$t('graph.confidenceInterval')}}</text>
            <text text-anchor="middle" :class="{'small-ci' : ( (disease=='diab') || (disease=='osteoarth-male') || (disease=='osteoarth-female') ) }" style="fill:#3f9c35; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y+20" :x="confIntPos.x">
            ({{confInt.adj5[0]|confIntvlLow(disease)}}-{{confInt.adj5[1]|confIntvlHigh(disease)}})</text>
        </g>
        <g v-if="!(adjustSelection==5 || adjustSelection==10 || adjustSelection==15 || adjustSelection==20)">
          <text text-anchor="middle"  :class="{'small-ci' : ( (disease=='diab') || (disease=='osteoarth-male') || (disease=='osteoarth-female') ) }" style="fill:#001965; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y" :x="confIntPos.x">
            {{$t('graph.confidenceInterval')}}</text>
            <text text-anchor="middle" :class="{'small-ci' : ( (disease=='diab') || (disease=='osteoarth-male') || (disease=='osteoarth-female') ) }" style="fill:#001965; font-family:verdana ,serif; font-weight:700; font-size:15px;" :y="confIntPos.y+20" :x="confIntPos.x">
             ({{confInt.current[0]|confIntvlLow(disease)}}-{{confInt.current[1]|confIntvlHigh(disease)}})</text>
        </g>
        
      </svg>
    </b-col>
  </b-row>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: "lineChart",
    mounted: function() {
      // set graph height
      switch (this.disease) {
        case "cancer":
          this.graphHeight=186;
          break;
        case "pcos":
          this.errorAt = 40;
          this.graphHeight=204;
          this.confIntPos= {y: (this.$i18n.locale=='sp'? this.confIntPos.y+34 : this.confIntPos.y+15), x: (this.$i18n.locale=='sp'? this.confIntPos.x : this.confIntPos.x+10)};
          break;
        case "nafld":
          this.errorAt = 40;
          this.graphHeight=204;
          this.confIntPos= {y: (this.$i18n.locale=='sp'? this.confIntPos.y+35 : this.confIntPos.y+17), x: this.confIntPos.x};
          break;
        case "hypertension":
          this.errorAt = 40;
          this.graphHeight=204;
          this.confIntPos= {y: (this.$i18n.locale=='sp'? this.confIntPos.y+15 : this.confIntPos.y-2), x: this.confIntPos.x};
          break;
        case "diab":
          this.graphHeight=186;
          this.confIntPos= {y: (this.$i18n.locale=='sp'? this.confIntPos.y+7 : this.confIntPos.y+8), x: (10 + this.confIntPos.x + 13)};
          break;
        case "dyslip":
          this.errorAt = 40;
          this.graphHeight=188;
          this.error20= {y:46, x:197};
          this.error50= {y:43, x:205};
          this.dlpAdj=3;
          this.confIntPos= {y: (this.$i18n.locale=='sp'? this.confIntPos.y+7 : this.confIntPos.y+8), x: this.confIntPos.x};
          break;
        default:
          this.graphHeight=204;
          this.confIntPos= {y: (this.$i18n.locale=='sp'? this.confIntPos.y+20 : this.confIntPos.y+20), x: this.confIntPos.x+17};
          
      }
      // create labels
      this.createLabelsY();
      this.createLabelsX();
      this.calcRiskPoints();
      
      console.log('in LC - conf int: '+JSON.stringify(this.confInt));
      
    },
    components: {},
    computed: {
      ...mapGetters('userData', ['userData']),
    },
    data() {
      return {
        
        dlpAdj: 0,
        error20: {y:46, x:197},
        error50: {y:43, x:195},
        confIntPos: {
          y: parseInt(this.$t('graph.confIntPosy')), 
          x: parseInt(this.$t('graph.confIntPosx')),
        },
        errorAt: 50,
        gridlines: [],
        graphWidth: 516,
        graphHeight: 186,
        lblYMarginX: 28,
        xlabelpos: [],
        ylabelpos: [],
        currentRisk: {x:0, y:0},
        adj5Risk: {x:0, y:0},
        adj10Risk: {x:0, y:0},
        adj15Risk: {x:0, y:0},
        adj20Risk: {x:0, y:0},
        currentText: {x:0, y:0},
        adj5Text: {x:0, y:0},
        adj10Text: {x:0, y:0},
        adj15Text: {x:0, y:0},
        adj20Text: {x:0, y:0},
        textOffset: {
          curr: {x:0, y:14},
          adj5: {x:20, y:14},
          adj10: {x:0, y:17},
          adj15: {x:0, y:19},
          adj20: {x:0, y:18},
        },
        labelY: {
          count: 0,
          height: 0,
        },
        labelX: {
          count: 0,
          width: 0,
        }
      };
    },
    props: {
      disease: {
        type: String,
        required: true
      },
      risk: {
        type: Object,
      },
      adjustSelection: {
        type: Number,
      },
      confInt: {
        type: Object,
      },
      lblStartY: {
        type: Number,
        default: 0
      },
      lblEndY: {
        type: Number,
        default: 2.5
      },
      lblSkipY: {
        type: Number,
        default: 0.5
      },
      lblStartX: {
        type: Number,
        default: 20
      },
      lblEndX: {
        type: Number,
        default: 50
      },
      lblSkipX: {
        type: Number,
        default: 2
      },
    },
    filters: {
      labelY: function(value) {
        if (value==0.0) {
          return '0';
        } else if(value%1==0) {
          return value+'.'+'0';
        } else {
          return value;
        }
      },
      
      curvePoints: function(value, disease) {
        switch (disease) {
        case "cancer":
          if((value % 1) == 0) {
            return value+'.'+'00';
          } else if (value.toString().split(".")[1].length==1) {
            return value+'0';
          } else {
            return value;
          }
        case "pcos":
        case "osteoarth-male":
        case "osteoarth-female":
          if(value%1==0) {
            return value+'.'+'0';
          } else {
            return value;
          }
        case "diab":
        case "dyslip":
          if(value%1==0) {
            return value+'.'+'0'+'%';
          } else {
            return value+'%';
          }
        case "nafld":
        case "hypertension":
          return value+'%';
        default:
          return value;
      }
      },
      
      confIntvlHigh: function(value, disease) {
        switch (disease) {
        case "cancer":
          if((value % 1) == 0) {
            return value+'.'+'00';
          } else if (value.toString().split(".")[1].length==1) {
            return value+'0';
          } else {
            return value;
          }
        case "pcos":
        case "osteoarth-male":
        case "osteoarth-female":
          if(value%1==0) {
            return value+'.'+'0';
          } else {
            return value;
          }
        case "diab":
        case "dyslip":
          if(value%1==0) {
            return value+'.'+'0'+'%';
          } else {
            return value+'%';
          }
        case "nafld":
        case "hypertension":
          return value+'%';
        default:
          return value;
      }
      },
      
      confIntvlLow: function(value, disease) {
        switch (disease) {
        case "cancer":
          if((value % 1) == 0) {
            return value+'.'+'00';
          } else if (value.toString().split(".")[1].length==1) {
            return value+'0';
          } else {
            return value;
          }
        case "pcos":
        case "nafld":
        case "osteoarth-male":
        case "osteoarth-female":
          case "diab":
        case "dyslip":
          if(value%1==0 && value!==0) {
            return value+'.'+'0';
          } else {
            return value;
          }
        default:
          return value;
      }
      },
      
      labelX: function(value,disease) {
        if (value==40 && (disease=='dyslip'||disease=='pcos' ||disease=='nafld' ||disease=='hypertension')) {
          return value+'+';
        } else {
          return value;
        }
      },
    },
    methods: {
      checkLabelBoundries: function(risk,offset) {
        offset.y= risk.y-offset.y<38? 0-offset.y-21: offset.y;
        offset.x= risk.x-offset.x<70? (70-offset.x): (risk.x-offset.x>510? risk.x-510: offset.x);
        return offset;
      },
      createLabelsY: function() {
        this.ylabelpos=[];
        this.gridlines = [];
        var labelCount = (this.lblEndY - this.lblStartY) / this.lblSkipY;
        var labelHeight = (this.graphHeight) / (labelCount);
        this.labelY={count:labelCount, height:labelHeight};
        var y=this.graphHeight+16;
        var labelAdjustment;
        for(var i=0; i<=labelCount; i++) {
          var value = this.lblStartY + (i * this.lblSkipY);
          labelAdjustment = i==0?0:i==labelCount?5:3;
          this.ylabelpos.push({
              x:this.lblYMarginX,
              y:y+labelAdjustment,
              value:value,
              hightlight: value==1?true:( (this.disease=='dyslip'||this.disease=='hypertension'
              || this.disease=='nafld'||this.disease=='diab')? (value==0?true: false) :false)
              });
          
          if(i !== 0 && i !== labelCount) {
            this.gridlines.push({
              x1:35, 
              x2:this.graphWidth+33, 
              y1:y, 
              y2:y,
              hightlight: value==1?true:( (this.disease=='dyslip'||this.disease=='hypertension' || this.disease=='nafld'||this.disease=='diab')? (value==0?true: false) :false)
              });
          }
          y = y - labelHeight;
        } //end for
      },
      createLabelsX: function() {
        this.xlabelpos=[];
        var labelCount = (this.lblEndX - this.lblStartX) / this.lblSkipX;
        var labelWidth= (this.graphWidth-18)/labelCount;
        this.labelX={count:labelCount, width:labelWidth};
        var x=34+9;
        // Loop through the Labels 
        for(var i=0; i<=labelCount; i++) {
          var value = this.lblStartX + (i * this.lblSkipX);
          this.xlabelpos.push({
            x:x,
            y:this.graphHeight+36,
            value:value
          });
          x = x+labelWidth;     
        }
      },
      
      isOverlapBorderY: function(label, risk)  {
        var adj=0;
        if (label>(this.graphHeight+14)) {
          // console.log('OVERLAPPING bottom BORDER');
            return (this.graphHeight+14);
          }
          else if (label<40) {
            // console.log('OVERLAPPING top BORDER');
            adj= this.disease=="diab" && this.userData.calc.bmi.adj5>46? 18 : 0;
              return risk + 20 +25+adj;
            // }
          }
          else {
            return label;
          }
      },
      
      adjustBottomLeftValues: function (label, risk, txtWidth) {
        if (risk.y>189) {
          if (this.disease=="osteoarth-male" || this.disease=="osteoarth-female") {
            if (label.y<risk.y) {label.y = this.graphHeight+14;}
            label.x= risk.x+27+ (txtWidth/2);
          }
          else if (this.disease=="nafld") {
            label.x= risk.x+37+ (txtWidth/2);
          }
        }
        return label;
      },
      
      isOverlapBorderX: function(curr, label, risk, txtWidth) {
        if (label.x<(35+txtWidth/2)) {
            // console.log('OVERLAPPING LEFT BORDER');
            label.x = 37+txtWidth/2;
            if (curr.x - label.x < (txtWidth+10)) {
              label.y = label.y<risk.y? risk.y+20+9+(risk.y-label.y): label.y;
            }
          }
          else if ( (label.x+txtWidth/2) > 551) {
            // console.log('OVERLAPPING RIGHT BORDER');
            label.x=551-txtWidth/2-4;
            // console.log('after - '+label.x);
          }
          return label;
      },
       
      calcRiskPoints: function() { 
        // get bmi within range
        var bmi = Math.round(this.userData.bmi > this.lblEndX ? this.lblEndX : (this.userData.bmi < 20 ? 20:this.userData.bmi));
        var bmi5 = Math.round(this.userData.calc.bmi.adj5 > this.lblEndX ? this.lblEndX : (this.userData.calc.bmi.adj5 < 20 ? 20: this.userData.calc.bmi.adj5));
        var bmi10 = Math.round(this.userData.calc.bmi.adj10 > this.lblEndX ? this.lblEndX : (this.userData.calc.bmi.adj10 < 20 ? 20: this.userData.calc.bmi.adj10));
        var bmi15 = Math.round(this.userData.calc.bmi.adj15 > this.lblEndX ? this.lblEndX : (this.userData.calc.bmi.adj15 < 20 ? 20: this.userData.calc.bmi.adj15));
        var bmi20 = Math.round(this.userData.calc.bmi.adj20 > this.lblEndX ? this.lblEndX : (this.userData.calc.bmi.adj20 < 20 ? 20: this.userData.calc.bmi.adj20));
        // console.log('bmi: '+bmi, bmi5, bmi10, bmi15, bmi20);
        
        // get risk
        var risk = parseFloat(this.risk.current).toFixed(2);
        var risk5 = parseFloat(this.risk.adj5).toFixed(2);
        var risk10 = parseFloat(this.risk.adj10).toFixed(2);
        var risk15 = parseFloat(this.risk.adj15).toFixed(2);
        var risk20 = parseFloat(this.risk.adj20).toFixed(2);
        var labelHeight = this.labelY.height;  
        
        // get graph points position
        this.currentRisk.y = 16 + ( (labelHeight/this.lblSkipY) * ((this.lblEndY - risk))) ;
        this.currentRisk.x = 34 + ( (this.graphWidth/(this.lblEndX-this.lblStartX)) * (bmi - this.lblStartX)) ;
        
        
        this.adj5Risk.y = 16 + ( (labelHeight/this.lblSkipY) * ((this.lblEndY - risk5))) ;
        this.adj5Risk.x = 34 +9+ ( ((this.graphWidth-18)/(this.lblEndX-this.lblStartX)) * (bmi5 - this.lblStartX)) ;
        
        this.adj10Risk.y = 16 + ( (labelHeight/this.lblSkipY) * ((this.lblEndY - risk10))) ;
        this.adj10Risk.x = 34 +9+ ( ((this.graphWidth-18)/(this.lblEndX-this.lblStartX)) * (bmi10 - this.lblStartX)) ;
        
        this.adj15Risk.y = 16 + ( (labelHeight/this.lblSkipY) * ((this.lblEndY - risk15))) ;
        this.adj15Risk.x = 34 +9+ ( ((this.graphWidth-18)/(this.lblEndX-this.lblStartX)) * (bmi15 - this.lblStartX)) ;
        
        this.adj20Risk.y = 16 + ( (labelHeight/this.lblSkipY) * ((this.lblEndY - risk20))) ;
        this.adj20Risk.x = 34 +9+ ( ((this.graphWidth-18)/(this.lblEndX-this.lblStartX)) * (bmi20 - this.lblStartX)) ;
        
        // keep points within horizontal range
        this.currentRisk.x=this.currentRisk.x<43?43:(this.currentRisk.x>(this.graphWidth+9)?this.graphWidth-9+34:this.currentRisk.x);
        this.adj5Risk.x=this.adj5Risk.x<43?43:(this.adj5Risk.x>(this.graphWidth+9)?this.graphWidth-9+34:this.adj5Risk.x);
        this.adj10Risk.x=this.adj10Risk.x<43?43:(this.adj10Risk.x>(this.graphWidth+9)?this.graphWidth-9+34:this.adj10Risk.x);
        this.adj15Risk.x=this.adj15Risk.x<43?43:(this.adj15Risk.x>(this.graphWidth+9)?this.graphWidth-9+34:this.adj15Risk.x);
        this.adj20Risk.x=this.adj20Risk.x<43?43:(this.adj20Risk.x>(this.graphWidth+9)?this.graphWidth-9+34:this.adj20Risk.x);
        var txtWidth = 70;
        var addOffset = { curr: 0, adj5: 0, adj10: 0, adj15: 0, adj20: 0};
        switch (this.disease) {
            case "nafld":
              addOffset.curr = 10;
              txtWidth=76;
              break;
            case "hypertension":
              addOffset.curr = 5;
              txtWidth=76;
              break;
            case "pcos":
              txtWidth=47;
              break;
            case "osteoarth-male":
            case "osteoarth-female":
              txtWidth=50;
              break;
            case "diab":
              addOffset.adj10 = 17;
              txtWidth = bmi<33 ? 86: 106;
               break;
            case "dyslip":
               addOffset.curr = 10;
              addOffset.adj10 = 17;
              txtWidth=106;
              break;
          }
        // Set graph points text position
        this.textOffset= {
          curr: bmi<23? (this.disease=="nafld"|| this.disease=="dyslip"? {x:0, y:31} : {x:0, y:20} ) : (bmi>46 && this.disease=="cancer" ? {x:0, y:19} : (this.disease=="diab" ? {x:9, y:26} : {x:0, y:16}) ),
          adj5: {x:20, y: this.disease=="diab"|| this.disease=="dyslip" ? (bmi5>46? 30 : 16 ) : 16},
          adj10: {x: this.disease=="diab"|| this.disease=="dyslip" ? 9: 0, y:19},
          adj15: {x:this.disease=="diab"|| this.disease=="dyslip" ? 9: 0, y:21},
          adj20: {x:this.disease=="diab"|| this.disease=="dyslip" ? 9: 0, y:20}
        };
        // Avoid overlapping of current and adjusted values
        
        // Design scenario
        if (bmi==33 && ( (bmi-bmi5)>1) && ( (bmi5-bmi10)>1) ) {
          // console.log('DD values');
          switch (this.disease) {
            case "cancer":
              this.textOffset.adj5= {x:43, y:8 };
              this.textOffset.adj10= {x:15 , y:17 };
              this.textOffset.adj15= {x:0 , y:19 };
              this.textOffset.adj20= {x:0 , y:18 };
              break;
              
            case "dyslip":
              this.textOffset= {
                  curr: {x:0, y:20},
                  adj5: {x:70, y:20},
                  adj10: {x:20, y:20},
                  adj15: {x:0, y:20},
                  adj20: {x:0, y:20},
                };
                break;
                
            case "nafld":
              this.textOffset= {
                  curr: {x:10, y:15},
                  adj5: {x:37, y:14},
                  adj10: {x:8, y:15},
                  adj15: {x:8, y:17},
                  adj20: {x:0, y:20},
                };
              break;
            case "hypertension":
              this.textOffset= {
                curr: {x:-2, y: 22},
                adj5: {x: 43, y: 12},
                adj10: {x:18, y:17},
                adj15: {x:10, y:19},
                adj20: {x:0, y:18},
              };
              break;
              case "pcos":
                this.textOffset.curr.y= 20;
              this.textOffset.adj5.x= 15;
              this.textOffset.adj5.y= 19;
              break;
            case "osteoarth-male":
            case "osteoarth-female":
              this.textOffset= {
                curr: {x:0, y: 16},
                adj5: {x: 28, y: 12},
                adj10: {x:0, y:18},
                adj15: {x:0, y:14},
                adj20: {x:0, y:17},
              };
              break;
            case "diab":
              this.textOffset= {
                curr: {x:-10, y: 18},
                adj5: {x: 53, y: 15},
                adj10: {x: 17, y: 19},
                adj15: {x: 8, y: 17},
                adj20: {x: -10, y: 20},
              };
               break;
          }
          
        this.currentText= {x: this.currentRisk.x-this.textOffset.curr.x, y: this.currentRisk.y-this.textOffset.curr.y};
        this.adj5Text= {x: this.adj5Risk.x-this.textOffset.adj5.x, y: this.adj5Risk.y-this.textOffset.adj5.y};
        this.adj10Text= {x: this.adj10Risk.x-this.textOffset.adj10.x, y: this.adj10Risk.y-this.textOffset.adj10.y};
        this.adj15Text= {x: this.adj15Risk.x-this.textOffset.adj15.x, y: this.adj15Risk.y-this.textOffset.adj15.y};
        this.adj20Text= {x:this.adj20Risk.x-this.textOffset.adj20.x, y: this.adj20Risk.y-this.textOffset.adj20.y};
        
        }
        else {   
                    
        this.currentText= {x: this.currentRisk.x-this.textOffset.curr.x<(35+txtWidth/2)? 37+txtWidth/2: ( this.currentRisk.x-this.textOffset.curr.x>(35+516-5-txtWidth/2)? (33-5+516-txtWidth/2) : this.currentRisk.x-this.textOffset.curr.x), 
        y: this.currentRisk.y-this.textOffset.curr.y<40 ? 40: this.currentRisk.y-this.textOffset.curr.y};
        this.adj5Text= {x: this.adj5Risk.x-this.textOffset.adj5.x, y: this.adj5Risk.y-this.textOffset.adj5.y};
        this.adj10Text= {x: this.adj10Risk.x-this.textOffset.adj10.x, y: this.adj10Risk.y-this.textOffset.adj10.y};
        this.adj15Text= {x: this.adj15Risk.x-this.textOffset.adj15.x, y: this.adj15Risk.y-this.textOffset.adj15.y};
        this.adj20Text= {x:this.adj20Risk.x-this.textOffset.adj20.x, y: this.adj20Risk.y-this.textOffset.adj20.y};
        
        // adjust current value if it overlaps with curve
         if ( this.currentText.y==40 && (this.currentRisk.y-40)<32 ) {
           if (this.disease == "diab") {
             this.currentText.x=this.currentText.x-9;
           }
           else {
              this.currentText.y = (this.currentRisk.y+9+40+addOffset.curr);
              console.log('display below point - ');
           }
        } 
        // console.log('AFTER this.currentText',this.currentText.x,' - ',this.currentText.y); 
        
         // --------------------------------------- adj 5
       
        // display adj5 value inside graph box if out of box
          this.adj5Text = this.isOverlapBorderX(this.currentText, this.adj5Text, this.adj5Risk, txtWidth);
          this.adj5Text.y = this.isOverlapBorderY(this.adj5Text.y, this.adj5Risk.y);
          // console.log('after calc 5 adj - '+this.adj5Text.y);  
          if (this.currentText.x - this.adj5Text.x < (txtWidth+10)) {
            // console.log('5 - OVERLAPPING LBL X');
            // console.log('BEFORE this.adj5Text',this.adj5Text.x,' - ',this.adj5Text.y); 
            // if adj5 overlaps
            if (Math.abs(this.currentText.y - this.adj5Text.y) < 30 ) {
              // console.log('5 - OVERLAPPING LBL Y',(this.currentText.y - this.adj5Text.y),' - ',30);
              // if curr is above the point, display adj below the point
              if (this.currentText.y<this.currentRisk.y) {
                // console.log('current label above');
                this.adj5Text.y = this.adj5Risk.y + 9 + 30 + addOffset.adj10;
                this.adj5Text.x = this.adj5Risk.x;
              }
              else {
                // console.log('current label below');
                // adjust labels to avoid overlapping with high slope curves
                if (this.disease=="hypertension" || this.disease=="nafld" || this.disease=="pcos") {
                  this.adj5Text.y = this.currentText.y + 9 + 20 + addOffset.adj10;
                }
                // move adj label to left of curr
                else {
                  this.adj5Text.x= this.adj5Text.x - (txtWidth- (this.currentText.x - this.adj5Text.x) + 5);
                  this.adj5Text.y= this.adj5Text.y + 6; 
                }
              }
              // chk if out of graph after adjustment
              this.adj5Text = this.isOverlapBorderX(this.currentText, this.adj5Text, this.adj5Risk, txtWidth);
              this.adj5Text.y = this.isOverlapBorderY(this.adj5Text.y, this.adj5Risk.y);
            }
            
            
            // adjust labels overlapping bottom left border
            this.adj5Text = this.adjustBottomLeftValues (this.adj5Text, this.adj5Risk, txtWidth);
          } 
          // console.log('AFTER this.adj5Text',this.adj5Text.x,' - ',this.adj5Text.y);   
          
          // ------------------------------------------ adj 10
          
          this.adj10Text = this.isOverlapBorderX(this.currentText, this.adj10Text, this.adj10Risk, txtWidth);
          this.adj10Text.y = this.isOverlapBorderY(this.adj10Text.y, this.adj10Risk.y);
          
          if ( (this.currentText.x - this.adj10Text.x) < (txtWidth+10)) {
            // console.log('10 - OVERLAPPING LBL X: ',(this.currentText.x - this.adj10Text.x),' - ',txtWidth);
            if (Math.abs(this.currentText.y - this.adj10Text.y) < 30 ) {
              // console.log('10 - OVERLAPPING LBL Y: ',(this.currentText.y - this.adj10Text.y),' - ',30);
              if (this.currentText.y<this.currentRisk.y) {
                this.adj10Text.y = this.adj10Risk.y + 9 + 30 + addOffset.adj10;
              }
              else {
                if (this.disease=="hypertension" || this.disease=="nafld" || this.disease=="pcos") {
                  this.adj10Text.y = this.currentText.y + 9 + 20 + addOffset.adj10;
                }
                else {
              this.adj10Text.x= this.adj10Text.x - (txtWidth- (this.currentText.x - this.adj10Text.x) + 7);
              this.adj10Text.y= this.adj10Text.y + 4;
              }}}
            this.adj10Text = this.isOverlapBorderX(this.currentText, this.adj10Text, this.adj10Risk, txtWidth);
            this.adj10Text.y = this.isOverlapBorderY(this.adj10Text.y, this.adj10Risk.y);
            this.adj10Text = this.adjustBottomLeftValues (this.adj10Text, this.adj10Risk, txtWidth);
          } 
          
          // -------------------------------------------------- adj 15
          
          this.adj15Text = this.isOverlapBorderX(this.currentText, this.adj15Text, this.adj15Risk, txtWidth);
          this.adj15Text.y = this.isOverlapBorderY(this.adj15Text.y, this.adj15Risk.y);
          if (this.currentText.x - this.adj15Text.x < (txtWidth+10)) {
            // console.log('15 - OVERLAPPING LBL X');
            if (Math.abs(this.currentText.y - this.adj15Text.y) < 30 ) {
              // console.log('15 - OVERLAPPING LBL Y: ',(this.currentText.y - this.adj15Text.y),' - ',30);
              if (this.currentText.y<this.currentRisk.y) {
                // console.log('15 - curr at top');
                this.adj15Text.y = this.adj15Risk.y + 9 + 30 + addOffset.adj10;
              }
              else {
                if (this.disease=="hypertension" ||  this.disease=="pcos") {
                  this.adj15Text.y = this.currentText.y + 9 + 20 + addOffset.adj15;
                }
                else {
              this.adj15Text.x= this.adj15Text.x - (txtWidth- (this.currentText.x - this.adj15Text.x) + 10);
              }}
            this.adj15Text = this.isOverlapBorderX(this.currentText, this.adj15Text, this.adj15Risk, txtWidth);
            this.adj15Text.y = this.isOverlapBorderY(this.adj15Text.y, this.adj15Risk.y);
            }
            this.adj15Text = this.adjustBottomLeftValues (this.adj15Text, this.adj15Risk, txtWidth);
          }
          
          // ------------------------------------------------- adj 20
          // console.log('1 - 20: ',(this.adj20Text.x),' - ',(this.adj20Text.y));
          this.adj20Text = this.isOverlapBorderX(this.currentText, this.adj20Text, this.adj20Risk, txtWidth);
          this.adj20Text.y = this.isOverlapBorderY(this.adj20Text.y, this.adj20Risk.y);
          // console.log('2 - 20: ',(this.adj20Text.x),' - ',(this.adj20Text.y));
          if ( (Math.abs(this.currentText.x - this.adj20Text.x)) < (txtWidth) ) {
            // console.log('20 - OVERLAPPING LBL X');
            // console.log( (Math.abs(this.currentText.x - this.adj20Text.x)), 'curr 20 diff - with txtWidth: ',(txtWidth),' - y diff', this.currentText.y,' - ',this.adj20Text.y);
            if (Math.abs(this.currentText.y - this.adj20Text.y) < 30 ) {
              // console.log('20 - OVERLAPPING LBL Y: ',(this.currentText.y - this.adj20Text.y),' - ',30);
              if (this.currentText.y<this.currentRisk.y) {
                this.adj20Text.y = this.adj20Risk.y + 9 + 30 + addOffset.adj10;
              }
              else {
                // adjust labels to avoid overlapping with high slope curves
                if (this.disease=="hypertension" || this.disease=="pcos") {
                  this.adj20Text.y = this.currentText.y + 9 + 20 + addOffset.adj10;
                }
                // move adj label to left of curr
                else {
              this.adj20Text.x= this.adj20Text.x - (txtWidth- (this.currentText.x - this.adj20Text.x) + 10);
              }}
            this.adj20Text = this.isOverlapBorderX(this.currentText, this.adj20Text, this.adj20Risk, txtWidth);
            this.adj20Text.y = this.isOverlapBorderY(this.adj20Text.y, this.adj20Risk.y);
            }
            
          } 
          // console.log('3 - 20: ',(this.adj20Text.x),' - ',(this.adj20Text.y));
          // console.log('chk error overlap: '+(this.adj20Text.x - (txtWidth/2))+' < '+367);
          if ( (this.adj20Text.x - (txtWidth/2) < 367) && (this.userData.bmi>this.errorAt) && (this.adj20Text.y<this.adj20Risk.y) ) {
            // console.log('error overlap: '+(this.adj20Text.x - (txtWidth/2))+' < '+50);
            this.adj20Text.y = this.adj20Risk.y + 9 + 30 + addOffset.adj10;
          }
          // console.log('4 - 20: ',(this.adj20Text.x),' - ',(this.adj20Text.y));
          this.adj20Text = this.adjustBottomLeftValues (this.adj20Text, this.adj20Risk, txtWidth);
          console.log('5 - 20: ',(this.adj20Text.x),' - ',(this.adj20Text.y));
        }
        
        
        // out of range bmi values
            if (bmi==bmi20) { this.adj5Text = this.adj10Text=this.adj15Text=this.adj20Text=this.currentText;}
            else if (bmi==bmi15) { this.adj5Text = this.adj10Text= this.adj15Text=this.currentText;}
            else if (bmi==bmi10) { this.adj5Text = this.adj10Text=this.currentText;}
            else if (bmi==bmi5) { this.adj5Text = this.currentText;}
      },
      
    },
    
    watch: {
      disease: function(oldVal, newVal) {
        if(oldVal !== newVal) {
          this.createLabelsY();
          this.createLabelsX();
          this.calcRiskPoints();
        }
      }
    }
  };
</script>


<style lang="scss" scoped>
  .small-ci {
    font-size: 13px !important;
  }
</style>
